import { __awaiter } from "tslib";
import { createInstance } from '@optimizely/react-sdk';
import { getLocale } from "@pb/utils/locale";
import { default as getOptimizelyVanillaSDKInstance } from "@pb/utils/common/getOptimizelyVanillaSDKInstance";
import { default as getOptimizelyFallbackId } from "@pb/utils/common/getOptimizelyFallbackId";
import { default as getCookie } from "@pb/utils/getCookie";
import { initOptimizelyVanillaHelpersSDK } from "@pb/utils/optimizely";
import { getOptimizelyDefaultOptions } from "@pb/utils/optimizely";
import { NiBConstant } from './constants';
export const getOptimizelyInstance = () => __awaiter(void 0, void 0, void 0, function* () {
    const optimizelyClientInstance = getOptimizelyVanillaSDKInstance();
    const result = yield optimizelyClientInstance.onReady();
    const locale = getLocale();
    const userId = getOptimizelyFallbackId();
    const screenSize = window === null || window === void 0 ? void 0 : window.innerWidth;
    const attributes = {
        locale,
        screenSize,
    };
    return { result, optimizelyClientInstance, attributes, userId };
});
export function getVariation(variableKeys) {
    return __awaiter(this, void 0, void 0, function* () {
        const { result, optimizelyClientInstance, attributes, userId } = yield getOptimizelyInstance();
        const variation = {
            flag: false,
            download_app_content: {},
            banner_description: '',
            banner_title: '',
        };
        if (result.success) {
            const isFeatureEnabled = optimizelyClientInstance.isFeatureEnabled(NiBConstant.EXPERIMENT_KEY, userId, attributes);
            if (isFeatureEnabled) {
                variation.flag = true;
                variableKeys.forEach((variableKey) => {
                    variation[variableKey] = optimizelyClientInstance.getFeatureVariable(NiBConstant.EXPERIMENT_KEY, variableKey, userId, attributes);
                });
            }
        }
        return variation;
    });
}
export const trackOptimizelyEvent = (eventKey, eventTags, overrideUserId, attributes) => {
    var _a;
    const optimizelyFullStackOptOut = getCookie('ab_optout');
    const optimizelyInstance = createInstance({
        sdkKey: process.env.OPTIMIZELY_SDK_KEY,
    });
    const overrideAttributes = Object.assign(Object.assign({}, (_a = optimizelyInstance.user) === null || _a === void 0 ? void 0 : _a.attributes), attributes);
    localStorage.setItem('optimizelyUserAttributes', JSON.stringify(overrideAttributes));
    if (optimizelyFullStackOptOut === null) {
        optimizelyInstance.track(eventKey, overrideUserId, attributes, eventTags);
    }
};
export const trackOptimizelyVanillaEvent = (eventKey, tags) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { attributes, userId } = getOptimizelyDefaultOptions();
    if (!(window === null || window === void 0 ? void 0 : window.optimizelyVanillaHelpersSDKInstance)) {
        yield initOptimizelyVanillaHelpersSDK();
    }
    if (!attributes.optOut) {
        (_a = window === null || window === void 0 ? void 0 : window.optimizelyVanillaHelpersSDKInstance) === null || _a === void 0 ? void 0 : _a.track(eventKey, userId, Object.assign({}, attributes), tags);
    }
});
//# sourceMappingURL=optimizely.js.map